import { CaseStudies, ContentWithLink, Logos, NavBarColorSwitcher, Spacer, StatementHero, WhatWeDo, Cta } from "components";
import fusebox from "images/client-logos/fusebox.svg";
import gpd from "images/client-logos/gpd.svg";
import insanelab from "images/client-logos/insanelab.svg";
import tnbt from "images/client-logos/tnbt.svg";
import wpserved from "images/client-logos/wpserved.svg";
import wupwt from "images/client-logos/wupwt.png";
import vlt from "images/client-logos/vlt.svg";
import um from "images/client-logos/um.svg";
import { graphql } from "gatsby";
import * as React from 'react';
export default {
  CaseStudies,
  ContentWithLink,
  Logos,
  NavBarColorSwitcher,
  Spacer,
  StatementHero,
  WhatWeDo,
  Cta,
  fusebox,
  gpd,
  insanelab,
  tnbt,
  wpserved,
  wupwt,
  vlt,
  um,
  graphql,
  React
};